import router from './router'
import store from './store'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, removeToken } from '@/utils/auth'
import { isRelogin } from '@/utils/request'


NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/register']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    to.meta.title && store.dispatch('settings/setTitle', to.meta.title)
    /* has token*/


    // console.log(to.path)
    //防止死循环  用户不会清除token和localStorage  重新输入网址清空登录信息重新登陆
    if (sessionStorage.getItem('pwdFlag') == 0 && to.path == '/') {
      localStorage.clear()
      sessionStorage.clear()
      removeToken()

      next({ path: '/login', replace: true })

      return;
    }

    //  如果头次登录就修改密码, 并且不能跳转其他页面
    if (sessionStorage.getItem('pwdFlag') == 0 && to.path != '/editPassword') {
      next({ path: '/editPassword', replace: true })
      return;
    }

    if (to.path === '/login') {

      // console.log(1)
      next({ path: '/' })
      NProgress.done()
    } else if (whiteList.indexOf(to.path) !== -1) {
      // console.log(2)
      next()
    } else {
      if (store.getters.roles.length === 0) {
        // console.log(3)
        isRelogin.show = true
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then((res) => {
          //  如果头次登录就修改密码, 并且不能跳转其他页面

          if (res.data.pwdFlag == 0) {
            sessionStorage.setItem('pwdFlag', res.data.pwdFlag)
            next({ path: '/editPassword', replace: true })
            return;
          }


          isRelogin.show = false;

          next({ ...to, replace: true })

        }).catch(err => {
          console.log(err)
          store.dispatch('LogOut').then(() => {
            // location.href= '/login'
            // localStorage.clear()
            // ElMessage.error(err)
            


            // next({ path: '/login' })
          })
        })
      } else {

        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})